import {MaskedAsteriskIcon} from '../CreditCard/icons/MaskedAsteriskIcon.tsx';
import type {CreditCardScheme} from '../CreditCard';
import {formatCardNumberFromParts} from '../CreditCard/util/formatCardNumber.ts';

interface Props {
    scheme: CreditCardScheme;
    prefix: string;
    suffix: string;
}

export function MaskedCardDigits({scheme, prefix, suffix}: Props) {
    const groups = formatCardNumberFromParts(scheme, prefix, suffix);

    return (
        <span className="inline-flex items-center gap-[1ch]">
            {groups.map((group, groupIndex) => (
                <span key={groupIndex} className="inline-flex items-center">
                    {[...group].map((char, charIndex) => (
                        char === '*' ? (
                            <span key={charIndex} className="inline-flex w-[1ch] justify-center">
                                <MaskedAsteriskIcon className="h-[0.7em] w-auto" />
                            </span>
                        ) : (
                            <span key={charIndex}>{char}</span>
                        )
                    ))}
                </span>
            ))}
        </span>
    );
}
